import { Router } from '@angular/router';
import { takeWhile, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { TiposCombustiveisService } from './../../../services/tipos-combustiveis/tipos-combustiveis.service';
import { TiposCombustiveis } from './../../../services/tipos-combustiveis/tipos-combustiveis';

import { FichaService } from './../../ficha-veiculo.service';
import { FichaCadastroTipo } from './../ficha-cadastro-tipo';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { isEmpty } from 'lodash';
import { VeiculoSimulacao } from '../ficha-cadastro-resultado-parcial/model/proposta/veiculo-simulacao';
import { removeFichaContent } from '../helpers/salvarFicha';
import { Veiculo, VeiculoEmSeuNome } from '../model/veiculo';
import { FichaCadastro } from './../ficha-cadastro';
import { FichaCadastroSharedService } from './../shared/ficha-cadastro-shared.service';

@Component({
  selector: 'app-ficha-cadastro-veiculo',
  templateUrl: './ficha-cadastro-veiculo.component.html',
  styleUrls: ['./ficha-cadastro-veiculo.component.scss'],
})
export class FichaCadastroVeiculoComponent implements OnInit {
  @Input() fichaCadastro: FichaCadastro;

  form: FormGroup;
  formFirstVeiculo: FormGroup;

  listaTipoVeiculo = [];
  listaMarca = [];
  listaAnoModelo = [];
  listaModelo = [];
  listaVersao = [];
  listaTiposCombustiveis: TiposCombustiveis[] = [];
  veiculos: Veiculo[] = [{}];
  veiculoEmSeuNome: VeiculoEmSeuNome = {};

  formValidFirstVeiculo: boolean;

  public formValidArray: boolean[] = [];

  public fichaCadastroTipo = FichaCadastroTipo;

  public isPlacaInvalida = false;

  constructor(
    private sharedService: FichaCadastroSharedService,
    private fichaService: FichaService,
    private tiposCombustiveisService: TiposCombustiveisService
  ) {}

  ngOnInit() {
    this.verificaPendenciaVeiculo();
    this.initiVerificaPendenciaObservable();
  }

  initiVerificaPendenciaObservable() {
    this.sharedService.verificaPendenciaObservable.subscribe(() => {
      this.verificaPendenciaVeiculo();
    });
  }

  private verificaPendenciaVeiculo(): void {
    if (
      !this.hasIdSimulacao ||
      !this.fichaCadastro ||
      !this.fichaCadastro.veiculosGetDados
    ) {
      return;
    }

    this.veiculos = this.fichaCadastro.veiculosGetDados.map((m) =>
      this.mapVeiculoAndPendencia(m)
    );
  }

  private mapVeiculoAndPendencia(veiculo: VeiculoSimulacao): Veiculo {
    const {
      placa,
      uf,
      categoria,
      marca,
      anoModelo,
      modelo,
      versao,
      utilizacaoAgropecuaria,
      zero,
      cotacao,
      fipe,
    } = veiculo;

    let pendencia = null;
    if (
      placa &&
      this.fichaCadastro &&
      this.fichaCadastro.veiculosPendencia &&
      this.fichaCadastro.veiculosPendencia.length
    ) {
      pendencia =
        this.fichaCadastro.veiculosPendencia.find((p) => p.placa === placa) ||
        null;
    }

    if (placa && pendencia) {
      return {
        pendencia,
        veiculoPlaca: placa,
        ufLicenciamento: uf,
        isUtilizacaoAgropecuaria: utilizacaoAgropecuaria,
        saved: true,
        inSimular: true,
      };
    }

    return {
      cotacao,
      pendencia,
      fipe,
      veiculoPlaca: placa,
      ufLicenciamento: uf,
      veiculoCategoria: categoria.getId(),
      veiculoMarca: { id: marca.getId(), descricao: marca.getDescricao() },
      veiculoAno: anoModelo,
      veiculoModelo: { id: modelo.getId(), descricao: modelo.getDescricao() },
      veiculoVersao: { id: versao.getId(), descricao: versao.getDescricao() },
      isUtilizacaoAgropecuaria: utilizacaoAgropecuaria,
      isZeroKm: zero,
      saved: true,
      inSimular: true,
    };
  }

  public get isNextAvailable(): boolean {
    if (this.veiculos.length === 1) {
      if (this.veiculos.some((v) => v.pendencia)) {
        return (
          this.formValidFirstVeiculo && this.veiculos.every((v) => !v.isEdit)
        );
      }
      return (
        this.formValidFirstVeiculo ||
        (this.veiculos && this.veiculos.every((v) => v.saved && !v.isEdit))
      );
    }
    return (
      this.veiculos &&
      this.veiculos.every((v) => v.saved && !v.isEdit) &&
      this.veiculos.some((v) => !v.pendencia)
    );
  }

  public changeFormVeiculoLista(form: FormGroup): void {
    this.formFirstVeiculo = form;
  }

  public changeFormValidList(value: boolean): void {
    this.formValidFirstVeiculo = value;
  }

  onClickPrevious() {
    this.fichaCadastro.onClickPrevious();
  }

  private get isPrimeiroVeiculoEmPreenchimento(): boolean {
    return (
      this.formFirstVeiculo &&
      this.formFirstVeiculo.get('isPrimeiroVeiculo').value
    );
  }

  private get veiculosFormatSimular(): any[] {
    let veiculos: Veiculo[];
    if (
      this.fichaCadastro &&
      this.fichaCadastro._tipo ===
        this.fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND &&
      this.veiculos.length === 1
    ) {
      veiculos = [this.formFirstVeiculo.value];
      veiculos = veiculos.map((v) => ({ ...v, veiculoPlaca: '' }));
    } else if (this.veiculos.some((v) => v.pendencia && v.veiculoPlaca)) {
      veiculos = this.veiculos;
      veiculos.forEach((v) => {
        if (!v.pendencia && v.veiculoCategoria) {
          v.veiculoPlaca = '';
        }
      });
    } else {
      veiculos = isEmpty(this.veiculos[0])
        ? [this.formFirstVeiculo.value]
        : this.veiculos;
    }

    return veiculos.map((veiculo: Veiculo) => {
      let fipe;
      if (veiculo.veiculoVersao && veiculo.veiculoVersao.codigoMolicar) {
        fipe = veiculo.veiculoVersao.codigoMolicar;
      } else if (veiculo.fipe) {
        fipe = veiculo.fipe;
      }
      return {
        fipe,
        placa: veiculo.veiculoPlaca || '',
        uf: veiculo.ufLicenciamento || '',
        categoria: veiculo.veiculoCategoria
          ? { id: veiculo.veiculoCategoria }
          : {},
        marca: veiculo.veiculoMarca
          ? {
            id: veiculo.veiculoMarca.id,
            descricao: veiculo.veiculoMarca.descricao,
          }
          : {},
        anoModelo: veiculo.veiculoAno || '',
        modelo: veiculo.veiculoModelo
          ? {
            id: veiculo.veiculoModelo.id,
            descricao: veiculo.veiculoModelo.descricao,
          }
          : {},
        versao: veiculo.veiculoVersao
          ? {
            id: veiculo.veiculoVersao.id,
            descricao: veiculo.veiculoVersao.descricao,
          }
          : {},
        cotacao: veiculo.cotacao || 0,
        utilizacaoAgropecuaria: veiculo.isUtilizacaoAgropecuaria || false,
        condicao: veiculo['inserirManual']
          ? 'USADO'
          : veiculo.isZeroKm
          ? 'ZERO'
          : 'USADO',
        descricao: veiculo.veiculoPlaca
          ? ''
          : `${veiculo.veiculoMarca.descricao} ${veiculo.veiculoModelo.descricao} | ${veiculo.veiculoAno} | ${veiculo.veiculoVersao.descricao}`,
        veiculoPrincipal: veiculo.isPrimeiroVeiculo || false,
      };
    });
  }

  public get hasPrimeiroVeiculo(): boolean {
    return (
      this.veiculos.some((v) => v.isPrimeiroVeiculo) ||
      (isEmpty(this.veiculos[0]) && this.isPrimeiroVeiculoEmPreenchimento)
    );
  }

  private get veiculoProprio(): any {
    const {
      isVeiculoEmMeuNome,
      isNaoSeiPlaca,
      veiculoPlaca,
      veiculoCategoria,
      veiculoMarca,
      veiculoAno,
      veiculoModelo,
      veiculoVersao,
    } = this.veiculoEmSeuNome;

    if (!isVeiculoEmMeuNome || this.hasPrimeiroVeiculo) {
      return {};
    }

    if (!isNaoSeiPlaca) {
      return {
        placa: veiculoPlaca,
      };
    }

    return {
      anoModelo: veiculoAno,
      categoria: { id: veiculoCategoria },
      marca: { id: veiculoMarca },
      modelo: { id: veiculoModelo },
      versao: { id: veiculoVersao },
    };
  }

  onClickNext() {
    if (this.hasIdSimulacao) {
      this.fichaCadastro.setPayload('id', this.fichaCadastro.getIdSimulacao());
    }

    this.fichaCadastro.setPayload('veiculos', this.veiculosFormatSimular);
    this.fichaCadastro.setPayload('plataformaInclusao', 'WEB');
    this.fichaCadastro.setPayload(
      'tipoProduto',
      this.fichaCadastro.tipoVeiculo
    );
    this.fichaCadastro.onClickNext();
    removeFichaContent();
    this.sharedService.simularProposta();
    this.putDataClient();
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  public get hasIdSimulacao(): boolean {
    return this.fichaCadastro.getIdSimulacao() !== null;
  }

  getTipoCombustiveis() {
    this.tiposCombustiveisService
      .getTipoCombustiveis()
      .pipe(take(1))
      .subscribe((tipocombustivel: TiposCombustiveis[]) => {
        this.listaTiposCombustiveis = tipocombustivel;
      });
  }
}
